var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddEditContacts01 = function SvgAddEditContacts01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_edit_contacts-01_svg2__a",
    x1: -3.42,
    x2: 121.33,
    y1: 141.58,
    y2: 16.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#add_edit_contacts-01_svg2__a",
    id: "add_edit_contacts-01_svg2__b",
    x1: 43.04,
    x2: 167.78,
    y1: 188.04,
    y2: 63.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#add_edit_contacts-01_svg2__a",
    id: "add_edit_contacts-01_svg2__c",
    x1: 89.8,
    x2: 214.54,
    y1: 234.8,
    y2: 110.05
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97.24 81.83c22.57 0 40.92-18.36 40.92-40.91S119.81 0 97.24 0 56.32 18.36 56.32 40.92s18.35 40.91 40.92 40.91m0-67.54c14.68 0 26.63 11.95 26.63 26.63s-11.95 26.63-26.63 26.63S70.61 55.6 70.61 40.92s11.95-26.63 26.63-26.63",
    style: {
      fill: "url(#add_edit_contacts-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.97 181.74-.02-.02c-1.19-.88-2.58-1.49-4.16-1.49H51.51c-8.18 0-14.83-6.65-14.83-14.83 0-16.14 6.3-31.33 17.73-42.77 11.43-11.43 26.65-17.73 42.85-17.73s31.41 6.3 42.84 17.73c2.48 2.47 4.72 5.15 6.68 7.97.46.66 1.06 1.15 1.68 1.61 2.4 1.76 5.7 1.97 8.27.18a7.14 7.14 0 0 0 1.79-9.94 73 73 0 0 0-8.3-9.91c-14.13-14.13-32.94-21.92-52.94-21.92s-38.82 7.78-52.95 21.92-21.92 32.91-21.92 52.87c0 16.05 13.06 29.12 29.12 29.12h56.28c3.95 0 7.14-3.2 7.14-7.14 0-2.36-1.22-4.35-2.98-5.65",
    style: {
      fill: "url(#add_edit_contacts-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.46 166.36h-12.22v-12.22c0-3.94-3.19-7.14-7.14-7.14s-7.14 3.2-7.14 7.14v12.22h-12.22c-3.95 0-7.14 3.2-7.14 7.14s3.2 7.14 7.14 7.14h12.22v12.22c0 3.94 3.2 7.14 7.14 7.14s7.14-3.2 7.14-7.14v-12.22h12.22c3.95 0 7.14-3.2 7.14-7.14s-3.19-7.14-7.14-7.14",
    style: {
      fill: "url(#add_edit_contacts-01_svg2__c)"
    }
  }));
};
export default SvgAddEditContacts01;